import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { Article, IGetArticlesApiParam } from '@common/domain/models/Article';
import { fetchArticles } from '@common/redux/content/actions';
import {fetchArticlesLoaderSelector, fetchCountMapSelector, getContentTypeMapSelector } from '@common/redux/content/selectors';

import Shimmer from '@components/atoms/Shimmer';
import MultipleSlider from '@components/Slider/MultipleSlider';

import Navigator from '@navigator/index';
import { NavigationUrl, URLs } from '@navigator/NavigationUrl';

import { ContentKey } from '@constants/config';

import ContentCard from '@presentation/Content/components/ContentCard';
import ContentSection from '@presentation/Content/components/ContentSection';
import FinanceCard from '@presentation/Content/components/FinanceCard';
import { ContentType, sectionSetting, TagType } from '@presentation/Content/config';

interface IProps {
    getDashboardContentList?: (params: IGetArticlesApiParam) => void;
    articleListLoader?: boolean;
    groupName?: string;
    heading?: string;
    contentTypeMap?: {};
    contentShortId?: string;
    countMap?: {},
    groupValues?: string[];
    tagType?: string;
    isGrouped?: boolean;
    isGuestPage?: boolean;
}

const ContentSectionContainer = (props: IProps) => {
    const { getDashboardContentList, articleListLoader,
        groupName, heading, contentTypeMap, countMap,groupValues, tagType, isGrouped, isGuestPage } = props;
    const [groupArticles, setGroupArticles] = useState([]);
    const CONTENT_LIMIT = 6;
    const PAGE_NUMBER = 1;
    const INCLUDE = 'isLiked';

    useEffect(() => {
        if (groupName !== ContentType.all) {
            getDashboardContentList({ tags: JSON.stringify({ [tagType]: groupValues.join(',') }), type: groupName, limit: CONTENT_LIMIT, page: PAGE_NUMBER, include: INCLUDE });
        } else {
            getDashboardContentList({ type: groupName, limit: CONTENT_LIMIT, page: PAGE_NUMBER, include: INCLUDE });
        }
    }, []);

    useEffect(() => {
        if (contentTypeMap) {
            setGroupArticles(contentTypeMap[groupName]?.length > 2 ? contentTypeMap[groupName]?.concat([{}]) : contentTypeMap[groupName]);
        }
    }, [contentTypeMap[groupName]]);

    const navigateToListingPage = () => {
        Navigator.push(NavigationUrl.generate(URLs.contentListingPage, {
            content: {
                key: tagType,
                [isGrouped ? TagType.GROUP : TagType.VALUE]: groupName,
            }
        }));
    };

    const navigateToDetailsPage = (content: Article) => {
        Navigator.push(NavigationUrl.generate(URLs.contentDetailsPage, {
            id: `${content.getSlug()}-${content.getShortId()}`
        }));
    };

    const getLatestContent = () => (
        <>
            {groupArticles?.length > 0 && (
                <MultipleSlider customSetting={sectionSetting}>
                    {groupArticles?.map((content: Article) => (groupName === ContentType.finance ? (
                        <FinanceCard
                            content={content}
                            onCardClick={() => navigateToDetailsPage(content)}
                        />
                    ) : (
                        <ContentCard content={content} onCardClick={() => navigateToDetailsPage(content)} />
                    )))}
                </MultipleSlider>
            )}
        </>
    );

    if (articleListLoader) {
        return <Shimmer />;
    }

    if (isGuestPage || groupArticles?.length === 0) {
        return null;
    }

    return (
        <>
            {(tagType !== ContentKey.TOPIC) && <ContentSection
                children={getLatestContent()}
                contentType={ContentType.latest}
                heading={heading}
                navigateToListingPage={navigateToListingPage}
                showSeeAll={countMap[groupName] > 6}
            />}
        </>
    );
};

export const mapStateToProps = (state: any, props: IProps) => {
    const { groupName } = props;
    return {
        articleListLoader: fetchArticlesLoaderSelector(state, groupName),
        contentTypeMap: getContentTypeMapSelector(state),
        countMap: fetchCountMapSelector(state),
    };
};

export const mapDispatchToProps = (dispatch: any) => ({
    getDashboardContentList: (params: IGetArticlesApiParam) => dispatch(fetchArticles(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContentSectionContainer);
